// views
import Link from "next/link";
import { Row, Col } from "antd";
import { useRouter } from "next/router";
import eleIcon from "~/public/static/icons/ele@3x.png";

export default (props) => {
  const { user } = props;
  const router = useRouter();
  return (
    <div className="mx-10 my-10">
      <Row type="flex" align="bottom" justify="space-between">
        <Col span={2}>
          <img src={eleIcon.src} width={24} height={24} />
        </Col>
        <Col span={22}>
          <div className="mx-20">
            <strong className="ele-value">{user.ele}</strong>
          </div>
        </Col>
      </Row>
      <Row type="flex" align="bottom" justify="space-between">
        <Col span={22} offset={2}>
          <div className="mx-20">
            <div className="my-5">
              <span className="text-secondary">电量</span>
            </div>
            <div className="my-5">
              {props.profile && (
                <div>
                  <Link legacyBehavior href="/ele_records">
                    <a className="ant-btn ant-btn-primary ant-btn-sm ant-btn-background-ghost">
                      查看详情
                    </a>
                  </Link>
                  &nbsp;
                  {router.pathname === "/profile/info" && (
                    <a
                      className="ant-btn ant-btn-primary ant-btn-sm ant-btn-background-ghost"
                      onClick={props.onClickCharge}>
                      充电
                    </a>
                  )}
                </div>
              )}
            </div>
          </div>
        </Col>
      </Row>

      <style jsx>
        {`
          .ele-value {
            font-size: 24px;
            line-height: 1;
            vertical-align: bottom;
          }
        `}
      </style>
    </div>
  );
};
